/**
 *
 * Asynchronously loads the component for ClientProfile
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ClientProfile = lazyLoad(
  () => import('./index'),
  module => module.ClientProfile,
);
